import React, { useRef, useEffect, useState } from "react";
import InputAdornment from "@mui/material/InputAdornment";
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        "& .MuiInputBase-root": {
            borderRadius: 10,
            "& .MuiInputBase-input": {
                font: "normal normal normal 16px / 25px Poppins",
                color: "#505050",
            },
            "& .MuiInputAdornment-root": {
                "& .MuiIconButton-root": {
                    background: "transparent",
                },
                "& .type-check": {
                    borderRadius: "50%",
                    fontSize: 27,
                },
                "& .type-checked": {
                    fill: "#2A7CD6",
                },
                "& .type-unchecked": {
                    background: "#EAEBEF 0% 0% no-repeat padding-box",
                    fill: "#DADADA",
                },
            },
            '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button':
                {
                    "-webkit-appearance": "none",
                    margin: 0,
                },
            '& input[type="number"]': {
                "-moz-appearance": "textfield", // for Firefox
            },
        },
        "& .MuiFormLabel-root": {
            font: "normal normal normal 19px/21px Poppins",
            color: "#505050",
            "&.Mui-focused": {
                color: "#505050",
            },
        },
        "& .MuiTypography-root": {
            fontSize: 16,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #B0B0B0",
            "& legend": {
                fontSize: "15.5px",
            },
        },
    },
});

function PercentageInput({
    id,
    name,
    type,
    value,
    label,
    placeholder,
    onChange,
    addTypeCheck,
    selectedType,
    errors,
    softLimit = null,
    softLimitWarningMessage = "Manager approval required",
    displaySoftLimitErrorMsg = 'yes'
}) {
    const classes = useStyles();
    const InputRef = useRef(null);
    const [validation_errors, setErrors] = useState(errors);
    
    // This could be extracted out into its own function. But it's okay for now.
    const showError = (addTypeCheck && !selectedType) || validation_errors?.[name]
    const showSoftLimitWarning = softLimit !== null && softLimit !== undefined && 
      value !== "" && 
      parseFloat(value) <= parseFloat(softLimit) && !showError && displaySoftLimitErrorMsg === 'yes';


    useEffect(() => {
        setErrors(errors);
    }, [errors]);

    const removeError = (key) => {
        const { [key]: _, ...rest } = validation_errors;
        setErrors(rest);
    };

    return (
        <TextField
            label={label}
            id="outlined-end-adornment"
            fullWidth
            className={classes.root}
            placeholder={placeholder}
            value={value}
            onChange={(e) => {
                if (e.target.value.length > 10) return;
                onChange(e);
                removeError(e.target.name);
            }}
            inputRef={InputRef}
            helperText={showSoftLimitWarning ? softLimitWarningMessage : ""}
            FormHelperTextProps={{
                style: {
                    color: showSoftLimitWarning ? '#ff9800' : 'inherit',
                    fontSize: '10px',
                    marginLeft: '8px',
                }
            }}
            error={(addTypeCheck && !selectedType) || validation_errors?.[name]}
            name={name}
            type={type}
            InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                maxLength: 12,
            }}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
}

export default PercentageInput;
